import { ROLE_PERMISSIONS } from "../constants/rolePermisssions";

export const hasPermission = (user, requiredPrivilege) => {
    if (!user) return false;
  
    const department = user.department?.toUpperCase();
    const role = user.role?.toUpperCase();
  
    const privileges = ROLE_PERMISSIONS[department]?.[role] || [];
  
    return privileges.includes(requiredPrivilege);
  };